export default "https://d1e6s5z4lzmgxx.cloudfront.net/ba82fc54-f5ca-4442-8850-d050cbc89c21/images/mezzoforte-icon.svg?baf7ed6b2a8c2e326ac2f66757fe3fa1";